import { dataTableDescarga } from "./DataTableDescarga";
import { dataTableDetalle } from "./DataTableDetallePedimento";
import { dataTablePedimentos } from "./DataTablePedimentos";

/**
 * Muestra el indicador de carga en las DataTables
 * @param {boolean} freeze
 */
export const freezeAllDataTables = (isFreeze = true) => {
    if (isFreeze) {
        dataTablePedimentos.freeze();
        dataTableDescarga.freeze();
        dataTableDetalle.freeze();
    }

    if (!isFreeze) {
        setTimeout(() => {
            dataTablePedimentos.unfreeze();
            dataTableDescarga.unfreeze();
            dataTableDetalle.unfreeze();
        }, 250);
    }
};

export const clearItemSelected = () => {
    dataTablePedimentos.options.data.forEach((itm) => delete itm["item-selected"]);
    dataTableDetalle.options.data.forEach((itm) => delete itm["item-selected"]);
};
